import { USER_ROLE } from '@/helpers/const';

export default () => ({
  userRole: USER_ROLE.STUDENT,
  userFirstName: '',
  userLastName: '',
  userName: '',
});
